import React from "react";
import Breadcrumb from "../components/elements/Breadcrumb";
import Head from "next/head";
import Partners from "../components/elements/Partners";
import Expert from "../components/elements/Expert";

const experts = [
  {
    name: "Furkan Pinar",
    title: "CEO",
    image: "/assets/imgs/placeholders/avatar-6.png",
    url: "https://www.linkedin.com/in/furkanpinar9/",
  },
  {
    name: "Emir Ozdemir",
    title: "Full-Stack Developer",
    image: "/assets/imgs/placeholders/avatar-5.png",
    url: "https://www.linkedin.com/in/emir-ozdemir-a44694207/",
  },
  {
    name: "Emre Ozturk",
    title: "Full-Stack Developer",
    image: "/assets/imgs/placeholders/avatar-3.png",
    url: "https://www.linkedin.com/in/emre-ozturk-a440b2126/",
  },
  {
    name: "Hakan Pinar",
    title: "Mobile Developer",
    image: "/assets/imgs/placeholders/avatar-4.png",
    url: "https://www.linkedin.com/in/pinarhakan/",
  },
  {
    name: "Fatih Günal",
    title: "Back-end Developer",
    image: "/assets/imgs/placeholders/avatar-8.png",
    url: "https://www.linkedin.com/in/fatihgunal/",
  },
  {
    name: "Taha Savran",
    title: "Full-Stack Developer",
    image: "/assets/imgs/placeholders/avatar-2.png",
    url: "https://www.linkedin.com/in/taha-savran-6b787415a/",
  },
  {
    name: "Kadir Aksu",
    title: "OutSystems Engineer",
    image: "/assets/imgs/placeholders/avatar-10.png",
    url: "https://www.linkedin.com/in/abdulkadir-aksu-be/",
  },
  {
    name: "Mikail Civelek",
    title: "Data Engineer",
    image: "/assets/imgs/placeholders/avatar-7.png",
    url: "https://www.linkedin.com/in/mikail-civelek-be/",
  },
  {
    name: "Ekrem Biler",
    title: "Mobile Developer",
    image: "/assets/imgs/placeholders/avatar-9.png",
    url: "https://www.linkedin.com/in/ekrembiler/",
  }
];

const About = () => {
  return (
    <>
      <Head>
        <meta charSet="utf-8"/>
        <link rel="shortcut icon" type="image/png" href="/assets/imgs/logos/favicon.png"/>
        <link rel="apple-touch-icon" href="/assets/imgs/logos/app/apple-touch-icon.png"/>
        <link
            rel="apple-touch-icon"
            sizes="48x48"
            href="/assets/imgs/logos/app/x48.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="72x72"
            href="/assets/imgs/logos/app/x72.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="96x96"
            href="/assets/imgs/logos/app/x96.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="144x144"
            href="/assets/imgs/logos/app/x144.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="168x168"
            href="/assets/imgs/logos/app/x168.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="192x192"
            href="/assets/imgs/logos/app/x192.png"
        />
        <meta name="msapplication-TileColor" content="#ffffff"/>
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <meta name="author" content="ANIVIA"/>
        <meta name="theme-color" content="#007aff"/>
        <link rel="manifest" href="/manifest.json"/>
        <meta name="description"
              content="ANIVIA te Heusden-Zolder helpt je met software toepassingen zoals websites, web applicaties en mobiele applicaties. Daarnaast bieden ze ook IT consultants aan."/>
        <title>Anivia | Over Ons</title>
      </Head>
      <Breadcrumb title="Over Ons" />
      <section className="py-10">
        <div
          className="hidden lg:block absolute inset-0 w-1/2 ml-auto z-0"
          style={{ zIndex: "-1" }}
        ></div>
        <div className="container">
          <div className="flex flex-wrap items-center -mx-3">
            <div className="w-full lg:w-1/2 px-3">
              <div>
                <div className="max-w-lg lg:max-w-md mx-auto lg:mx-0 mb-8 text-center lg:text-left">
                  <h2 className="text-3xl lg:text-5xl mb-4 font-bold font-heading animate__animatedanimated animate__fadeIn">
                    Toegewijd aan <span className="text-blue-500">mensen</span>{" "}
                    en de <span className="text-blue-500">toekomst</span>
                  </h2>
                  <p className="text-blueGray-400 leading-relaxed animate__animatedanimated animate__fadeIn">
                    Wij zijn <strong className="text-blue-500">Anivia</strong>,
                    uw digitale partner!
                    <span className="typewrite d-inline text-brand"></span>
                  </p>
                  <p className="text-blueGray-400 leading-relaxed animate__animatedanimated animate__fadeIn mt-3 text-sm">
                    Ons doel is om uw leven gemakkelijker te maken door u te
                    voorzien van innovatieve en gebruiksvriendelijke
                    softwareoplossingen. We willen u helpen tijd en geld te
                    besparen door uw taken en processen te automatiseren. Onze
                    producten zijn ontworpen om uw productiviteit en efficiëntie
                    te verbeteren.
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2 px-3 lg:bg-blueGray-10 mb-12 lg:mb-0 pb-10">
              <div className="flex items-center justify-center">
                <img
                  className="lg:max-w-lg"
                  src="/assets/imgs/illustrations/team.svg"
                  alt="Team cartoon"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pt-6 pb-2">
        <div className="container">
          <Partners />
        </div>
      </section>
      <section className="py-20 bg-blueGray-50" id="how-we-work">
        <div className="container">
          <div className="flex flex-wrap items-center justify-between max-w-2xl lg:max-w-full mb-12">
            <div className="w-full lg:w-1/2 mb-4 lg:mb-0">
              <h2 className="text-3xl md:text-4xl font-bold font-heading animate__animatedanimated animate__fadeIn">
                <span>We zijn uw partner om u te helpen uw</span>
                <span className="text-blue-500"> bedrijfsdroom </span>
                <br />
                <span>te starten.</span>
              </h2>
            </div>
            <div className="w-full lg:w-1/2">
              <p className="text-blueGray-400 leading-loose animate__animatedanimated animate__fadeIn">
                We innoveren voortdurend en breiden onze productportefeuille uit
                om aan de steeds veranderende behoeften van onze klanten te
                voldoen. We streven ernaar onze klanten producten en diensten
                van de hoogste kwaliteit te leveren.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap -mx-3 -mb-6 text-center">
            <div
              className="hover-up-5 w-full md:w-1/2 lg:w-1/3 px-3 mb-6 animate__animated animate__fadeIn"
              data-wow-delay=".1s"
            >
              <div className="p-12 bg-white shadow rounded">
                <div className="flex w-12 h-12 mx-auto items-center justify-center text-blue-800 font-bold font-heading bg-blue-200 rounded-full">
                  1
                </div>
                <img
                  className="h-36 mx-auto my-4"
                  src="/assets/imgs/illustrations/work-tv.webp"
                  alt="Analyse cartoon"
                />
                <h3 className="mb-2 font-bold font-heading text-xl">Analyse</h3>
                <p className="text-sm text-blueGray-400 leading-relaxed">
                  Een grondige analyse van de wijze waarop het project volgens
                  de behoeften van de klant kan worden gerealiseerd.
                </p>
              </div>
            </div>
            <div
              className="hover-up-5 w-full md:w-1/2 lg:w-1/3 px-3 mb-6 animate__animated animate__fadeIn"
              data-wow-delay=".1s"
            >
              <div className="p-12 bg-white shadow rounded">
                <div className="flex w-12 h-12 mx-auto items-center justify-center text-blue-800 font-bold font-heading bg-blue-200 rounded-full">
                  2
                </div>
                <img
                  className="h-36 mx-auto my-4"
                  src="/assets/imgs/illustrations/web.svg"
                  alt="Planning cartoon"
                />
                <h3 className="mb-2 font-bold font-heading text-xl">
                  Planning
                </h3>
                <p className="text-sm text-blueGray-400 leading-relaxed">
                  Projectplanning is essentieel om alles met betrekking tot het
                  project georganiseerd en methodisch te houden.
                </p>
              </div>
            </div>
            <div className="hover-up-5 w-full lg:w-1/3 px-3 mb-6">
              <div
                className="p-12 bg-white shadow rounded animate__animated animate__fadeIn"
                data-wow-delay=".1s"
              >
                <div className="flex w-12 h-12 mx-auto items-center justify-center text-blue-800 font-bold font-heading bg-blue-200 rounded-full">
                  3
                </div>
                <img
                  className="h-36 mx-auto my-4"
                  src="/assets/imgs/illustrations/tasks.svg"
                  alt="Developing cartoon"
                />
                <h3 className="mb-2 font-bold font-heading text-xl">
                  Ontwikkeling
                </h3>
                <p className="text-sm text-blueGray-400 leading-relaxed">
                  Tijdens de ontwikkeling van de software zorgen wij ervoor dat
                  we op dezelfde golflengte als de klant zitten zodat we alle
                  behoeften voorzien.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-20">
        <div className="container text-center">
          <div className="max-w-lg mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl mt-2 mb-4 font-bold font-heading">
              Vertrouw uw project toe aan onze
              <span className="text-blue-500"> specialisten</span>
            </h2>
            <p className="text-blueGray-400 leading-loose">
              Elk project is uniek, daarom zijn wij er voor je.
            </p>
          </div>
          <div className="flex flex-wrap -mx-5">
            {experts.map((expert) => (
              <Expert
                key={expert.name}
                name={expert.name}
                title={expert.title}
                image={expert.image}
                url={expert.url}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
